// Generated by CoffeeScript 2.7.0
var Admin__CommentsController, CommentItem;

import MessageNavActions from './messages/concerns/message_nav_actions.js';

import ToggleNavMenuAction from './toggle_nav_menu_action.js';

CommentItem = class CommentItem {
  constructor(el, confirmFunc) {
    var delete_reply_confirm_popover_el, reply_form;
    this.element = DomMaster.wrap(el);
    new Skylark.Elements.ButtonDropdown(this.element.find('.js-comment-action-btn-dropdown'));
    delete_reply_confirm_popover_el = this.element.find('.js-delete-reply-confirm-popover');
    if (delete_reply_confirm_popover_el.isPresent()) {
      new Skylark.Elements.ConfirmPopover(delete_reply_confirm_popover_el, {
        confirmFunc: confirmFunc
      });
    }
    reply_form = this.element.find('.reply-form');
    this.element.node.proxy('click', '.js-toggle-reply-form', function(event) {
      return reply_form.toggle();
    });
  }

};

export default Admin__CommentsController = (function() {
  class Admin__CommentsController extends Skylark.App.BaseController {
    index() {
      var comments_list_el;
      this.__toggleNavMenu();
      comments_list_el = DomMaster.find('.comments-list');
      if (comments_list_el.isPresent()) {
        this.items = {};
        this.baseUrl = DomMaster.find('.comments-list').data('base-url');
        return _.each(DomMaster.findAll('.comment-item'), (el) => {
          return this.items[parseInt(el.data('id'))] = new CommentItem(el, this._deletReplyFunc.bind(this));
        });
      }
    }

    _removeCommentItem(id) {
      var old_comment_item;
      id = parseInt(id);
      old_comment_item = this.items[id];
      if (!old_comment_item) {
        return;
      }
      old_comment_item.element.remove();
      return delete this.items[id];
    }

    _updateCommentItem(id, content) {
      var new_el, old_comment_item;
      id = parseInt(id);
      old_comment_item = this.items[id];
      if (!old_comment_item) {
        return;
      }
      new_el = old_comment_item.element.replaceWith(content);
      return this.items[id] = new CommentItem(new_el, this._deletReplyFunc.bind(this));
    }

    _deletReplyFunc(popover) {
      return Skylark.Libs.Ajax.delete(this.__composeDeleteUrl(popover.element.closest('.comment-item').data('id')), {
        responseType: 'script'
      });
    }

    __composeDeleteUrl(id) {
      return `${this.baseUrl}/${id}/destroy_reply`;
    }

  };

  Admin__CommentsController.include(MessageNavActions, ToggleNavMenuAction);

  return Admin__CommentsController;

}).call(this);

Skylark.App.Controllers.register({Admin__CommentsController});
